import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import startsWith from 'lodash/startsWith';
import toUpper from 'lodash/toUpper';
import trim from 'lodash/trim';

const defaultDeliveryRadius = 2;

const deg2rad = deg => deg * (Math.PI / 180);

const rad2deg = rad => (rad * 180) / Math.PI;

export const isPointInsidePolygon = (point, polygon) => {
  let isInside = false;

  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].lat;
    const yi = polygon[i].lng;
    const xj = polygon[j].lat;
    const yj = polygon[j].lng;

    const intersect = yi > point.lng !== yj > point.lng && point.lat < ((xj - xi) * (point.lng - yi)) / (yj - yi) + xi;

    if (intersect) isInside = !isInside;
  }

  return isInside;
};

export const getDistanceLatLng = (lat1, lon1, lat2, lon2, inKm = false, int = false) => {
  const theta = lon1 - +lon2;
  const dist =
    rad2deg(
      Math.acos(
        Math.sin(deg2rad(lat1)) * Math.sin(deg2rad(+lat2)) +
          Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(+lat2)) * Math.cos(deg2rad(theta))
      )
    ) || 0;
  const distance = dist * 60 * 1.1515;

  if (inKm) {
    const distanceInKm = distance * 1.60934;
    if (int) return distanceInKm;
    if (distanceInKm < 1) {
      // If distance is less than 1km we show it in meters
      return `${Math.round(distanceInKm * 1000)}m`;
    }

    // If distance is more than 1km we show it in km
    return `${Math.round(distanceInKm * 10) / 10}km`;
  }

  return Math.round(distance * 10) / 10;
};

export const isStoreAvailableForDelivery = (geoCoordinates, store, code) => {
  let allowedPostcodes;
  let availableDelivery;
  const postcode = get(geoCoordinates, 'postalcode', code);
  try {
    allowedPostcodes = JSON.parse(get(store, ['settings', 'preorder.delivery.postcode'], '[]'));
  } catch (e) {
    allowedPostcodes = [];
  }

  const deliveryPolygons = !!+(store.settings?.['preorder.delivery.polygons'] || 0);

  if (deliveryPolygons && store.deliveryAreasActive) {
    const storeDeliveryAreas = store.deliveryAreas && Array.isArray(store.deliveryAreas) ? store.deliveryAreas : [];
    const validDeliveryArea = storeDeliveryAreas.find(deliveryArea =>
      isPointInsidePolygon(
        { lat: geoCoordinates?.latitude, lng: geoCoordinates?.longitude },
        deliveryArea.positioningData.path
      )
    );

    availableDelivery = !!validDeliveryArea;
  } else if (!isEmpty(allowedPostcodes) && postcode) {
    const matchExact = !!+get(store, ['settings', 'preorder.delivery.postcode.matchExact']);
    availableDelivery = isPostcodeAllowed(postcode, allowedPostcodes, matchExact);
  } else {
    availableDelivery =
      getDistanceLatLng(
        get(geoCoordinates, 'latitude'),
        get(geoCoordinates, 'longitude'),
        get(store, 'lat'),
        get(store, 'long')
      ) <= +get(store, ['settings', 'preorder.delivery.radius'], defaultDeliveryRadius);
  }
  return availableDelivery;
};

const isPostcodeAllowed = (userPostcode, allowedPostcodes, matchExact) =>
  allowedPostcodes.some(allowedPostcode =>
    matchExact
      ? trim(userPostcode.slice(0, -3)) === toUpper(allowedPostcode)
      : startsWith(userPostcode, toUpper(allowedPostcode))
  );

export const storeLocation = (store, geoLocation, postCode) => {
  const distanceParams = [
    +get(geoLocation, 'latitude'),
    +get(geoLocation, 'longitude'),
    +get(store, 'lat'),
    +get(store, 'long'),
  ];

  return {
    ...store,
    hasDelivery: !!+get(store, ['settings', 'preorder.delivery.enabled'], false),
    deliverOnly: !!+get(store, ['settings', 'preorder.delivery.only'], false),
    availableDelivery: isStoreAvailableForDelivery(geoLocation, store, postCode),
    miles: getDistanceLatLng(...distanceParams) || null,
    km: getDistanceLatLng(...distanceParams, true) || null,
    kmWithoutText: getDistanceLatLng(...distanceParams, true, true) || null,
  };
};
